// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Rec_Class = require("../Control.Monad.Rec.Class/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_Bus = require("../Effect.Aff.Bus/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_EventSource = require("../Halogen.Query.EventSource/index.js");
var whenElem = function (condition) {
    return function (f) {
        if (condition) {
            return f(Data_Unit.unit);
        };
        return Halogen_HTML_Core.text("");
    };
};
var maybeElement = Data_Function.flip(Data_Maybe.maybe(Halogen_HTML_Core.text("")));
var intervalEventSource = function (dictMonadAff) {
    return function (time) {
        return Halogen_Query_EventSource.affEventSource(dictMonadAff)(function (emitter) {
            return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Aff.forkAff(Control_Monad_Rec_Class.forever(Effect_Aff.monadRecAff)(Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Aff_Class.liftAff(Effect_Aff_Class.monadAffAff)(Effect_Aff.delay(time)))(function () {
                return Halogen_Query_EventSource.emit(emitter)(Data_Unit.unit);
            }))))(function (fiber) {
                return Control_Applicative.pure(Effect_Aff.applicativeAff)(Effect_Aff.killFiber(Effect_Exception.error("Event source closed"))(fiber));
            });
        });
    };
};
var container = function (id) {
    return function (content) {
        return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.id_(id) ])(content);
    };
};
var className = function ($3) {
    return Halogen_HTML_Properties.class_(Halogen_HTML_Core.ClassName($3));
};
var busEventSource = function (dictMonadAff) {
    return function (bus) {
        return Halogen_Query_EventSource.affEventSource(dictMonadAff)(function (emitter) {
            return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Aff.forkAff(Control_Monad_Rec_Class.forever(Effect_Aff.monadRecAff)(Control_Bind.bindFlipped(Effect_Aff.bindAff)(Halogen_Query_EventSource.emit(emitter))(Effect_Aff_Bus.read(bus)))))(function (fiber) {
                return Control_Applicative.pure(Effect_Aff.applicativeAff)(Effect_Aff.killFiber(Effect_Exception.error("Event source closed"))(fiber));
            });
        });
    };
};
module.exports = {
    className: className,
    container: container,
    busEventSource: busEventSource,
    intervalEventSource: intervalEventSource,
    whenElem: whenElem,
    maybeElement: maybeElement
};
